import React from 'react';
import p from '../../styles/renewal/OnePage.module.css';
import { COMPANY } from './data';
import ContactForm from './ContactForm';

const Contact = () => (
  <section className={`${p.contactGrid} ${p.reveal}`}>
    <div className={`${p.cardLift} ${p.contactCard}`}>
      <ContactForm />
    </div>

    <div className={p.contactSide}>
      <div className={p.callCard}>
        <div className={p.callEyebrow} translate="no">CALL CENTER</div>
        <a className={p.callNumber} href={`tel:${COMPANY.phone.replace(/-/g, '')}`}>
          {COMPANY.phone}
        </a>
        <div className={p.callHours}>{COMPANY.hours}</div>
      </div>

      <div className={p.infoCard}>
        <div className={p.infoRow}>
          <div className={p.infoLabel}>대표자</div>
          <div className={p.infoValue}>{COMPANY.ceo}</div>
        </div>
        <div className={p.infoRow}>
          <div className={p.infoLabel}>사업자번호</div>
          <div className={p.infoValue}>{COMPANY.bizNo}</div>
        </div>
        <div className={p.infoRow}>
          <div className={p.infoLabel}>본사</div>
          <div className={p.infoValue}>
            {COMPANY.address}
            <br />
            {COMPANY.addressDetail}
          </div>
        </div>

        <div className={p.mapBox}>
          <iframe
            className={p.mapFrame}
            src={COMPANY.googleMapEmbed}
            title="주식회사 오퍼그룹 본사 위치"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
          <div className={p.mapFoot}>
            <div className={p.mapAddr}>
              {COMPANY.address}
              <br />
              {COMPANY.addressDetail}
            </div>
            <div className={p.mapLinks}>
              <a
                className={p.mapLink}
                href={COMPANY.naverMap}
                target="_blank"
                rel="noopener noreferrer"
              >
                네이버 지도
              </a>
              <a
                className={p.mapLink}
                href={COMPANY.kakaoMap}
                target="_blank"
                rel="noopener noreferrer"
              >
                카카오맵
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Contact;
